export default __webpack_public_path__ + "static/media/envelope.95cff2b2.png";